import React, { useState, useEffect } from 'react';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';
import './Hostel.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination,Navigation } from 'swiper/modules';
import 'swiper/css/navigation';




import 'swiper/css';
import 'swiper/css/pagination';

const Hostel = () => {
  const [hostelData, setHostelData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const getEmbedUrl = (idOrUrl) => {
    if (!idOrUrl || idOrUrl.length < 5) return null;
    if (idOrUrl.includes("youtube.com/embed/")) return idOrUrl;
    return `https://www.youtube.com/embed/${idOrUrl.trim()}`;
  };

  const formatImage = (img) => {
    if (!img) return null;
    return `${process.env.REACT_APP_API_URL}/public/${img.replace(/^\//, "")}`;
  };

  useEffect(() => {
    const fetchHostelData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/life-and-care");
        const data = response.data.data.hostel;

        // Format desktop banners
        const bannerImagesDesktop =
          data.banners?.desktop?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format mobile banners
        const bannerImagesMobile =
          data.banners?.mobile?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format sec4 gallery items
        const galleryItems = data.content.sec4_items.map(item => ({
          ...item,
          image: formatImage(item.image)
        }));

        setHostelData({
          ...data,
          bannerImagesDesktop,
          bannerImagesMobile,
          galleryItems
        });

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching Hostel data:", err);
        setError("Failed to load Hostel data");
        setIsLoading(false);
      }
    };

    fetchHostelData();
  }, []);

  if (isLoading) return <div>Loading Hostel details...</div>;
  if (error || !hostelData) return <div>{error}</div>;

  const {
    title,
    bannerImagesDesktop,
    bannerImagesMobile,
    content,
    galleryItems
  } = hostelData;

  const {
    sec2_heading,
    sec2_description,
    sec2_youtube,
    sec3_items
  } = content;

  const youtubeEmbedUrl = getEmbedUrl(sec2_youtube);

  return (
    <>
      {/* ---------------- BANNER ---------------- */}
      {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
        <DynamicBanner
          title={title}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      )}

      <section className="hostel-section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{title}</h2>
          </div>

          {/* Content + YouTube */}
          <div className="row mb-3 mb-md-5 d-flex justify-content-center align-items-center">
            <div className="col-lg-6 hostel-content order-2 order-md-1">
              <div dangerouslySetInnerHTML={{ __html: sec2_description }} />
            </div>

            <div className="col-lg-6 order-1 order-md-2">
              {youtubeEmbedUrl && (
                <div
                  className="video-container-hostel mb-3 mb-md-0"
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                    overflow: "hidden",
                    maxWidth: "100%",
                    backgroundColor: "#000",
                    borderRadius: "10px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
                  }}
                >
                  <iframe
                    src={youtubeEmbedUrl}
                    title={sec2_heading}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: "0",
                      borderRadius: "10px"
                    }}
                  ></iframe>
                </div>
              )}
            </div>
          </div>

          {/* Facilities Section */}
          <div className="row">
            <div className="col-12 ">
              <div className="sec-title text-center">
                <h2>{sec2_heading}</h2>
              </div>

              <div className="row d-flex justify-content-center align-items-center">
                {sec3_items.map((facility, index) => (
                  <div className="col-lg-3 col-md-6 mb-4 col-12" key={index}>
                    <div className="facility-hostel">
                      <div className="facility-hostel-icon">
                        {/* Convert icon text to FA class (fallback included) */}
                        <i className={`fa ${facility.icon?.toLowerCase().replace(/\s/g, '-') || "fa-check"}`}></i>
                      </div>
                      <h5>{facility.heading}</h5>
                      <p>{facility.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Gallery Section */}
         <div className="row">
  <div className="col-12">
    <div className="sec-title text-center">
      <h2>Hostel Gallery</h2>
    </div>

   <div className="hostel-gallery">
  <Swiper
    modules={[Autoplay, Pagination,Navigation]}
    spaceBetween={20}
    autoplay={false}
    navigation={true}

    pagination={{ clickable: true }}
    breakpoints={{
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    }}
    className="gallery-swiper"
  >
    {galleryItems.map((img, index) => (
      <SwiperSlide key={index}>
        <div className="gallery-slide">
          <img
            src={img.image}
            alt={img.text}
            className="gallery-image"
          />
          <div className="image-overlay">
            <span>{img.text}</span>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>


  </div>
</div>


        </div>
      </section>
    </>
  );
};

export default Hostel;
